import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, AlertX, ColorX, GFunc, GState, LocaleX, NavX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XScroll, XText } from "IZOX/_X";
import StepDot from "shared/StepDot";
import { QForm } from "IZOX/BLOCKS/Libs";
import { QFDropUpload } from "IZOX/BLOCKS/Libs/QForm/_gears";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import Styles from "__SYSDefault/Styles";
import ZValidate from "IZOX/STATIC/ZValidate";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import _ from "lodash";
import QUICKUI from "shared/QUICKUI";
import VarList from "shared/VarList";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PAgentProfile extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      step: 0
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._GetSelfProfile();
      this.GetBankList();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAgentProfile.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _GetSelfProfile = async () => {
    let res = await APIExpress.User.GetSelfProfile();
    let {Success, payload} = res;
    if(Success){
      this.setState({
        Q1Form: payload
      });
    }
  }

  GetBankList = async () => {
    let docs = await VarList.GetList("Bank");
    this.setState({
      banks: docs
    });
  }

  _toStep = (step) => {
    let Q1Form = GState.GET("profileFormData");
    this.setState({
      Q1Form: Q1Form
    });
    GState.UPDATE("profileStep", step);
  }

  _toRedirect = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Home");
  }

  _step1Back = () => {
    this._toRedirect();
  }

  _step1Next = () => {
    let {Q1Form} = this.state;
    if(!ZValidate.CheckAllFields(Q1Form, 
        [
          "meta.fullName.EN", "email", "telNo",
          "meta.companyName.EN", 
          "meta.officeNo", 
          "meta.companyEmail", 
          "meta.companyBRNo", "meta.companyAddress",
          "meta.bankPayee", "meta.bankACNo"
        ], ["required"])){
          AlertX.RequiredFields();
          return;
        }
    GState.UPDATE("profileFormData", Q1Form);
    this._toStep(1);
  }

  _step2Back = () => {
    this._toStep(0);
  }

  _step2Next = async () => {
    let {Q2Form} = this.state;
    let formData = GState.GET("profileFormData");
    let companyBRAtth = Accessor.Get(Q2Form, "meta.companyBRAtth");
    let allUploaded = _.every(companyBRAtth, o => o.active);
    if(_.isEmpty(companyBRAtth)){
      GFunc.Alert({
        EN: "Please upload at least one file for BR verification.",
        TC: "請上傳至少一個文件以進行 BR 驗證"
      }, "warn");
      return;
    }
    if(!allUploaded){
      GFunc.Alert({
        EN: "Please wait until all the files are uploaded.",
        TC: "請等待所有文件上傳完畢。"
      }, "warn");
      return;
    }
    let formCombined = Accessor.DeepReplace(formData, Q2Form);
    
    GState.UPDATE("profileFormData", formCombined);

    let res = await APIExpress.User.SubmitProfile(formCombined);
    let {Success, payload} = res;
    if(Success){
      await APIExpress.User.Refresh();
      this._toStep(2);
    }else{
      GFunc.Alert(payload, "error");
    }
  }

  Q1Change = (formValue) => {
    this.setState({
      Q1Form: formValue
    });
  }

  Q2Change = (formValue) => {
    this.setState({
      Q2Form: formValue
    });
  }

  validQ1 = () => {
    let {Q1Form} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(Q1Form, 
      [
        "meta.fullName.EN",
        "email",
        "telNo",
        "meta.companyName.EN",
        "meta.officeNo",
        "meta.companyEmail",
        "meta.companyBRNo",
        "meta.companyAddress.EN",
        "meta.bankID",
        "meta.bankPayee",
        "meta.bankACNo"
      ], "required");
    if(!valid) return false;
    return true;
  }

  validQ2 = () => {
    let {Q2Form} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(Q2Form, 
      [
        "meta.companyBRAtth",
        "meta.companyEALAtth"
      ], "required");
    if(!valid) return false;
    valid = ZValidate.CheckUploads(Q2Form, 
      [
        "meta.companyBRAtth",
        "meta.companyEALAtth"
      ]);
    if(!valid) return false;
    return true;
  }

  renderStep1QForm(){
    let {Q1Form} = this.state;
    return (
      <XScroll fullWidth>
        <QForm pT={29} fullWidth pH={24} pB={50}
          value={Q1Form}
          onChange={this.Q1Change}>
          {this.renderTitle(
            {
              EN: "Profile",
              TC: "個人資料"
            },
            // {
            //   EN: "Lorem ipsum dolor sit amet consectetur malesuada.",
            //   TC: "Lorem ipsum dolor sit amet consectetur malesuada."
            // }
          )}
          {this.renderSection1()}
          {this.renderSection2()}
          {this.renderSection3()}
          {this.renderButton(this._step1Back, this._step1Next, undefined, undefined, this.validQ1)}
        </QForm>
      </XScroll>
    );
  }

  renderTitle(title, subtitle){
    return (
      <VStack pV={24} fullWidth>
        <XText color={ColorX.CSS("Leaf")} fontSize={32} bold>
          {LocaleX.Parse(title)}
        </XText>
        <XText color={ColorX.CSS("Leaf")} fontSize={14} textAlign="|">
          {LocaleX.Parse(subtitle)}
        </XText>
      </VStack>
    );
  }

  renderSectionTitleLine(caption){
    return (
      <VStack fullWidth pB={24}>
        <HStack bgColor={ColorX.CSS("Axit")} pH={48 * window.innerWidth / 1070} pV={12} HAlign="[">
          <XText color={ColorX.CSS("pureWhite")} fontSize={16} bold>
            {LocaleX.Parse(caption)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderSection1M(){
     let {Q1Form} = this.state;
    return (
      <VStack fullWidth pB={48} HAlign="[" spacing={16}>
        {QUICKUI.AFSectionLine({
          EN: "Contact person information",
          TC: "聯絡人資訊"
        })}
        {QUICKUI.WebTextField("meta.fullName.EN",
          {EN: "Full name (English)", TC: "姓名 (英文)"},
          {starred: true, width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.fullName.EN"), 
            ["required"])},
        )}
        {QUICKUI.WebTextField("meta.fullName.TC",
          {EN: "Full name (Chinese)", TC: "姓名 (中文)"},
          {starred: false, width: "100%"},
        )}
        {QUICKUI.WebTextField("email",
          {EN: "Email", TC: "電郵"},
          {starred: true, readOnly: true, width: "100%"}
        )}
        {QUICKUI.WithZipCode("telNo", 
          { EN: "Mobile phone", TC: "手機號碼" },
          {starred: true, width: "100%", placeholder: {
            EN: "Enter your mobile phone no.",
            TC: "輸入你的電話號碼"
          }, errorMessage: 
          ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "telNo"), 
          ["required"])}
        )}
      </VStack>
    );
  }

  renderSection1PC(){
    let {Q1Form} = this.state;
    return (
      <VStack fullWidth pB={48} HAlign="[" spacing={16}>
        {QUICKUI.AFSectionLine({
          EN: "Contact person information",
          TC: "聯絡人資訊"
        })}
        <HStack spacing={24} HAlign="[">
          {QUICKUI.WebTextField("meta.fullName.EN",
            {EN: "Full name (English)", TC: "姓名 (英文)"},
            {starred: true, width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.fullName.EN"), 
              ["required"])},
          )}
          {QUICKUI.WebTextField("meta.fullName.TC",
            {EN: "Full name (Chinese)", TC: "姓名 (中文)"},
            {starred: false, width: "50%"},
          )}
        </HStack>
        <HStack spacing={24} HAlign="[">
          {QUICKUI.WebTextField("email",
            {EN: "Email", TC: "電郵"},
            {starred: true, readOnly: true, width: "50%"}
          )}
          {QUICKUI.WithZipCode("telNo", 
            { EN: "Mobile phone", TC: "手機號碼" },
            {starred: true, width: "50%", placeholder: {
              EN: "Enter your mobile phone no.",
              TC: "輸入你的電話號碼"
            }, errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "telNo"), 
            ["required"])}
          )}
        </HStack>
      </VStack>
    );
  }

  renderSection1(){
    return ResponsiveX.Split({
      0: () => this.renderSection1M(),
      [SysConfig.WebUIWidth]: () => this.renderSection1PC(),
    });
  }

  renderSection2M(){
    let {Q1Form} = this.state;
    return (
      <VStack fullWidth pB={48} HAlign="[" spacing={16}>
        {QUICKUI.AFSectionLine({
          EN: "Company information",
          TC: "公司資訊"
        })}
        {QUICKUI.WebTextField("meta.companyName.EN",
          {EN: "Company name (English)", TC: "公司名稱（英文）"},
          {starred: true, width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.companyName.EN"), 
            ["required"])},
        )}
        {QUICKUI.WebTextField("meta.companyName.TC",
            {EN: "Company name (Chinese)", TC: "公司名稱（中文）"},
            {starred: false, width: "100%"})}
        {QUICKUI.WebTextField("meta.officeNo",
          {EN: "Office Number", TC: "辦公室電話號碼"},
          {starred: true, width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.officeNo"), 
            ["required"])},
        )}
        {QUICKUI.WebTextField("meta.companyEmail",
          {EN: "Company email", TC: "公司電郵"},
          {starred: true, width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.companyEmail"), 
            ["required"])},
        )}
        {QUICKUI.WebTextField("meta.companyBRNo",
          {EN: "BR Number", TC: "商業登記號碼"},
          {starred: true, width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.companyBRNo"), 
            ["required"])},
        )}
        {QUICKUI.WithZipCode("meta.companyFax",
          {EN: "Contact fax", TC: "聯絡傳真"},
          {starred: false, width: "100%"},
        )}
        {QUICKUI.WebTextField("meta.companyAddress.EN",
          {EN: "Company Address (English)", TC: "公司地址 (英文)"},
          {starred: true, width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.companyAddress.EN"), 
            ["required"])},
        )}
        {QUICKUI.WebTextField("meta.companyAddress.TC",
          {EN: "Company Address (Chinese)", TC: "公司地址 (中文)"},
          {starred: false, width: "100%"},
        )}
      </VStack>
    );
  }

  renderSection2PC(){
    let {Q1Form} = this.state;
    return (
      <VStack fullWidth pB={48} HAlign="[" spacing={16}>
        {QUICKUI.AFSectionLine({
          EN: "Company information",
          TC: "公司資訊"
        })}
        <HStack spacing={24} HAlign="[">
          {QUICKUI.WebTextField("meta.companyName.EN",
            {EN: "Company name (English)", TC: "公司名稱（英文）"},
            {starred: true, width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.companyName.EN"), 
              ["required"])},
          )}
          {QUICKUI.WebTextField("meta.companyName.TC",
             {EN: "Company name (Chinese)", TC: "公司名稱（中文）"},
             {starred: false, width: "50%"})}
        </HStack>
        <HStack spacing={24} HAlign="[">
          {QUICKUI.WebTextField("meta.officeNo",
            {EN: "Office Number", TC: "辦公室電話號碼"},
            {starred: true, width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.officeNo"), 
              ["required"])},
          )}
          {QUICKUI.WebTextField("meta.companyEmail",
            {EN: "Company email", TC: "公司電郵"},
            {starred: true, width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.companyEmail"), 
              ["required"])},
          )}
        </HStack>
        <HStack spacing={24} HAlign="[">
          {QUICKUI.WebTextField("meta.companyBRNo",
            {EN: "BR Number", TC: "商業登記號碼"},
            {starred: true, width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.companyBRNo"), 
              ["required"])},
          )}
          {QUICKUI.WithZipCode("meta.companyFax",
            {EN: "Contact fax", TC: "聯絡傳真"},
            {starred: false, width: "50%"},
          )}
        </HStack>
        <HStack spacing={24} HAlign="[">
          {QUICKUI.WebTextField("meta.companyAddress.EN",
            {EN: "Company Address (English)", TC: "公司地址 (英文)"},
            {starred: true, width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.companyAddress.EN"), 
              ["required"])},
          )}
          {QUICKUI.WebTextField("meta.companyAddress.TC",
            {EN: "Company Address (Chinese)", TC: "公司地址 (中文)"},
            {starred: false, width: "50%"},
          )}
        </HStack>
      </VStack>
    );
  }

  renderSection2(){
    return ResponsiveX.Split({
      0: () => this.renderSection2M(),
      [SysConfig.WebUIWidth]: () => this.renderSection2PC(),
    });
  }

  renderSection3M(){
    let {banks, Q1Form} = this.state;
    return (
      <VStack fullWidth pB={48}>
        {QUICKUI.AFSectionLine({
          EN: "Bank Information",
          TC: "銀行資訊"
        })}
        {QUICKUI.WebTextField("meta.bankPayee",
          {EN: "Payee", TC: "收款人"},
          {width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankPayee"), 
            ["required"])}
        )}
        {QUICKUI.WebDropdown("meta.bankID", {
          EN: "Bank",
          TC: "銀行"
        }, banks, {width: "100%", valAccessor: "_id", capAccessor: "name", 
          placeholder: {EN: "Select Bank...", TC: "選擇銀行..."}, errorMessage: 
          ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankID"), 
          ["required"])})}
        {QUICKUI.WebPasswordField("meta.bankACNo",
          {EN: "Bank account number", TC: "銀行戶口號碼"},
          {width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankACNo"), 
            ["required"]), autoComplete: "off"}
        )}
      </VStack>
    );
  }

  renderSection3PC(){
    let {banks, Q1Form} = this.state;
    return (
      <VStack fullWidth pB={48}>
        {QUICKUI.AFSectionLine({
          EN: "Bank Information",
          TC: "銀行資訊"
        })}
        <HStack spacing={24} HAlign="[">
          {QUICKUI.WebTextField("meta.bankPayee",
            {EN: "Payee", TC: "收款人"},
            {width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankPayee"), 
              ["required"])}
          )}
          <HStack width={"50%"} spacing={16}>
            {QUICKUI.WebDropdown("meta.bankID", {
              EN: "Bank",
              TC: "銀行"
            }, banks, {width: "50%", valAccessor: "_id", capAccessor: "name", 
              placeholder: {EN: "Select Bank...", TC: "選擇銀行..."}, errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankID"), 
              ["required"])})}
            {QUICKUI.WebPasswordField("meta.bankACNo",
              {EN: "Bank account number", TC: "銀行戶口號碼"},
              {width: "50%", errorMessage: 
                ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankACNo"), 
                ["required"]), autoComplete: "off"}
            )}
          </HStack>
        </HStack>
      </VStack>
    );
  }

  renderSection3(){
    return ResponsiveX.Split({
      0: () => this.renderSection3M(),
      [SysConfig.WebUIWidth]: () => this.renderSection3PC(),
    });
  }

  renderButton(backFunc, nextFunc, 
    backCap = { EN: "Back", TC: "返回" },
    nextCap = { EN: "Next", TC: "下一步"},
    validFunc = null
  ){
    return (
      <HStack spacing={16}>
        <XButton {...Styles.QFBtnInverse} width={200} onPress={backFunc}>
          <HStack>
            <XText bold>
              {LocaleX.Parse(backCap)}
            </XText>
          </HStack>
        </XButton>
        <XButton {...Styles.QFBtn} width={200} onPress={nextFunc}
          disabled={!validFunc?.()}>
          <HStack>
            <XText bold>
              {LocaleX.Parse(nextCap)}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderStep2QForm(){
    let {Q2Form} = this.state;
    return (
      <XScroll>
        <QForm pT={10} fullWidth pH={24} pB={50} spacing={24}
          onChange={this.Q2Change} value={Q2Form}>
          {this.renderTitle(
            {
              EN: "Verify Your Business",
              TC: "驗證你的商業資格"
            },
            {
              EN: "In order to create an account, we need to be 100% sure that you are you.\nAs we're an insurance service, we have to comply with this.\nWhich will help us to build a secure system together",
              TC: "為了建立帳戶，我們需要 100% 確定您就是您本人。\n由於我們是保險服務機構，因此我們必須遵守這一點。\n這將有助於我們共同建構一個安全的系統"
            })}
          <VStack fullWidth spacing={10}>
            <HStack>
              <XText color={ColorX.CSS("Leaf")} bold>
                {LocaleX.Parse({
                  EN: "Business Registration Number",
                  TC: "商業登記號碼 (Business Registration Number)"
                })}
              </XText>
            </HStack>
            <HStack>
              <QFDropUpload 
                fileSizeLimit={10}
                name="meta.companyBRAtth"
                btnBgColor={ColorX.CSS("Axit")}
                color={ColorX.CSS("Stone")}
                previewColor={ColorX.CSS("Leaf")}
                accept=".jpg,.png,.pdf,.jpeg"
                instantUpload
                dropzone
                multiple
                uploadZoneProps={{
                  width: ResponsiveX.RefMin(300, 1070),
                }}
                previewZoneProps={{
                  width: ResponsiveX.RefMin(300, 1070),
                }}
                />
            </HStack>
          </VStack>
          <VStack fullWidth spacing={10}>
            <HStack>
              <XText color={ColorX.CSS("Leaf")} bold>
                {LocaleX.Parse({
                  EN: "Employment Agency License",
                  TC: "職業代理執照 (Employment Agency License)"
                })}
              </XText>
            </HStack>
            <HStack>
              <QFDropUpload 
                fileSizeLimit={10}
                name="meta.companyEALAtth"
                btnBgColor={ColorX.CSS("Axit")}
                color={ColorX.CSS("Stone")}
                previewColor={ColorX.CSS("Leaf")}
                accept=".jpg,.png,.pdf,.jpeg"
                instantUpload
                dropzone
                multiple
                uploadZoneProps={{
                  width: ResponsiveX.RefMin(300, 1070),
                }}
                previewZoneProps={{
                  width: ResponsiveX.RefMin(300, 1070),
                }}
                />
            </HStack>
          </VStack>
          {this.renderButton(this._step2Back, this._step2Next, undefined, 
            {
              EN: "Submit",
              TC: "提交"
            }, this.validQ2)}
        </QForm>
      </XScroll>
    );
  }

  renderThankYou(){
    return (
      <VStack fullHeight VAlign="-" spacing={24} pH={10}>
        <XText fontSize={32} color={ColorX.CSS("Leaf")} bold>
          {LocaleX.Parse({
            EN: "Thank You",
            TC: "多謝"
          })}
        </XText>
        <XText fontSize={14} color={ColorX.CSS("Leaf")} 
          maxWidth={ResponsiveX.Split({0: () => "100%", [SysConfig.WebUIWidth]: () => "50%"})} textAlign="|" overflowWrap="anywhere">
          {LocaleX.Parse({
            EN: "Hi, I hope you're doing well. We wanted to reach out to let you know that we've finished setting up your account. Our team will send you a the confirmation letter we sent via email when done verification. Thank you for taking the time to confirm the details, it's greatly appreciated.",
            TC: "嗨，我希望你一切都好。我們希望與您聯繫，讓您知道我們已完成您的帳戶設定。完成驗證後，我們的團隊將向您發送我們透過電子郵件發送的確認信。感謝您花時間確認詳細信息，非常感謝。"
          })}
        </XText> 
        <XButton {...Styles.QFBtnInverse} width={200} onPress={this._toRedirect}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Back to Home",
                TC: "返回首頁"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderStep(){
    let step = GState.GET("profileStep") ?? 0;
    switch(step){
      default: case 0: return this.renderStep1QForm();
      case 1: return this.renderStep2QForm();
      case 2: return this.renderThankYou();
    }
  }

  render(){
    let step = GState.GET("profileStep") ?? 0;
    return (
      <VStack bgColor={ColorX.CSS("Grass")} fullHeight fullWidth>
        <VStack maxWidth={"90%"} width={1070} bgColor={ColorX.CSS("pureWhite")} fullHeight>
          <HStack HAlign="[" height={40}>
            <StepDot curStep={step} maxStep={3} 
              inactiveColor={ColorX.CSS("NotQuiteWhite")}
              activeColor={ColorX.CSS("DeepBlueSea")} 
              style={{paddingTop: 12, marginLeft: 42}}/>
          </HStack>
          {this.renderStep()}
        </VStack>
      </VStack>
    );
  }

}

export default withRouter(observer(PAgentProfile));
